import { createEnv } from '@t3-oss/env-nextjs'
import { z } from 'zod'

const sessionSchema = z.object({
    publicId: z.string(),
})

const sessionMock = {
    publicId: '1234567890',
}

export const serverEnv = createEnv({
    server: {
        ACCOUNT_SESSION_COOKIE_NAME: z.string().min(1),
        ACCOUNT_SESSION_GCM_SECRET: z.string().length(32),
        ACCOUNT_SESSION_MOCK_ENABLE: z.stringbool().default(false),
        ACCOUNT_SESSION_MOCK: z
            .string()
            .min(1)
            .default(JSON.stringify(sessionMock))
            .transform((data) => sessionSchema.parse(JSON.parse(data))),
        CONTENT_LANG: z.enum(['en', 'ru']).default('en'),
        GOOGLE_TAG_MANAGER_APP_ID: z.string().default(''),
        IMAGE_CDN_URL: z.url(),
        LOG_LEVEL: z.enum(['error', 'warn', 'info', 'debug']).default('error'),
        NEWS_DB_DEBUG: z.stringbool().default(false),
        NEWS_DB_DSN: z.url(),
        NEWS_DB_MAX_CONNECTION_NUMBER: z.coerce.number(),
        PORTAL_LANG_LIST: z.string().transform((s) => s.split(',').map((lang) => lang.trim())),
        POSTS_PER_PAGE: z.coerce.number(),
        SENTRY_DSN: z.url(),
        SENTRY_ENVIRONMENT: z.string().min(1),
        SENTRY_TRACES_SAMPLE_RATE: z.coerce.number().min(0).max(1).default(1.0),
        SEO_INDEX_PAGE_ENABLE: z.stringbool().default(true),
        TRANSLATION_CACHE_FILE_PATH: z.string().optional(),
        TRANSLATION_CACHE_MAX_SIZE: z.coerce.number().default(7000), // NOTE: для us: 1 пост - 2 записи (заголовок и контент - с readmore будет 3 записи) на 13 языков = 26 записей; 45 постов в месяц = 1170 записей; за 6 месяцев = 7020 записей
        TRANSLATION_ENABLE: z.stringbool().default(false),
        TRANSLATION_GCS_PROJECT_ID: z.string().optional(),
        TRANSLATION_GCS_SERVICE_ACCOUNT_KEY: z.string().optional(),
        TRANSLATION_MOCK_ENABLE: z.stringbool().default(false),
    },
    experimental__runtimeEnv: {},
    skipValidation: process.env.SKIP_ENV_VALIDATION === 'true',
})
